<script>
  import http from '@/service/http'
  import { mapState } from 'vuex'

  export default {
    name: 'Form',
    data () {
      return {
        unidades: [{}],
        marcas: [{}],
        fornecedores: [{}],
        familias: [],
        categorias: [],
        produto: {
          id: '',
          unidade_id: '',
          codigo: '',
          produto: '',
          descricao: '',
          foto: '',
          fotos: [],
          marca_id: '',
          fornecedor_id: '',
          familia_id: '',
          categoria_id: '',
          ncm: '',
          unidade: '',
          estoque: '',
          estoque_minimo: '',
          valor_compra: '',
          valor_venda: '',
          valor_loja: '',
          loja: true,
          ativo: true
        },
        progress: 0,
        errorFile: false,
        options: {
          url: `${process.env.API_URL}/upload-image`,
          uploadMultiple: false,
          acceptedFiles: 'image/*',
          headers: {
            path: 'produtos',
            width: 800,
            height: 600,
            accept: 'all'
          }
        }
      }
    },
    mounted () {
      this.fecth()
    },
    watch: {
      '$route' () {
        if (this.$route.params.id != null) {
          this.fecth()
        }
      },
      hasAll () {
        if (this.hasAll) {
          this.all = true
        } else {
          this.all = false
        }
      }
    },
    methods: {
      validate: function () {
        this.$validator.validateAll().then(success => {
          if (!success) {
            return false
          } else {
            this.submit()
          }
        })
      },
      async submit () {
        const verb = this.isNew ? 'post' : 'put'
        const url = this.isNew ? '/produtos' : `/produtos/${this.produto.id}`
        const {data} = await http[verb](url, this.produto)
        if (data != null) {
          this.$emit('update-produtos-list', {produto: data.produto})
          this.$router.push({name: 'produtos.index'})
        }
      },
      async fecth () {
        this.clear()
        const {id} = this.$route.params
        if (id !== undefined) {
          const {data} = await http.get(`/produtos/${id}/edit`)
          this.produto = data.produto
          this.unidades = data.unidades
          this.marcas = data.marcas
          this.fornecedores = data.fornecedores
          this.familias = data.familias
          this.categorias = data.categorias
        } else {
          const {data} = await http.get(`/produtos/create`)
          this.unidades = data.unidades
          this.marcas = data.marcas
          this.fornecedores = data.fornecedores
          this.familias = data.familias
        }
        setTimeout(function () {
          window.Materialize.updateTextFields()
        }, 0)
      },
      async familiaChange () {
        const {data} = await http.get(`/familias/categorias/${this.produto.familia_id}/ajax`)
        this.categorias = data.categorias
        this.produto.categoria_id = ''
        setTimeout(function () {
          window.Materialize.updateTextFields()
        }, 0)
      },
      setCapa (indexFoto) {
        this.produto.fotos.forEach(function (item) {
          item.capa = false
        })
        this.produto.fotos[indexFoto].capa = true
      },
      clear () {
        this.produto = {
          id: '',
          unidade_id: '',
          codigo: '',
          produto: '',
          descricao: '',
          foto: '',
          fotos: [],
          marca_id: '',
          fornecedor_id: '',
          familia_id: '',
          categoria_id: '',
          unidade: '',
          ncm: '',
          estoque: '',
          estoque_minimo: '',
          valor_compra: '',
          valor_venda: '',
          valor_loja: '',
          loja: true,
          ativo: true
        }
      },
      totalProgress (progress, totalBytes, bytesSent) {
        this.progress = progress
      },
      complete (files, status, xhr) {
        if (files.errorMessage) {
          this.errorFile = true
        } else {
          this.errorFile = false
          this.produto.fotos.push({foto: xhr.response, capa: false})
          this.progress = 0
          if (this.produto.fotos.length === 1) {
            this.produto.fotos[0].capa = true
          }
        }
      },
      destroyImage () {
        this.$swal({
          title: 'Atenção',
          text: `deseja excluir a imagem?`,
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          cancelButtonColor: '#d33',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Sim, quero excluir!',
          reverseButtons: true
        }).then(() => {
          this.produto.foto = ''
        })
      },
      destroyFoto (indexFoto) {
        this.$swal({
          title: 'Atenção',
          text: `excluir uma foto é uma operação irreversível`,
          type: 'warning',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          cancelButtonColor: '#d33',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Sim, quero excluir!',
          reverseButtons: true
        }).then(() => {
          let foto = this.produto.fotos[indexFoto]
          if (!this.produto.fotos[indexFoto].id) {
            this.produto.fotos.splice(indexFoto, 1)
            window.Materialize.toast('Foto excluída!', 4000)
          } else {
            http.delete(`produtos/foto/${this.produto.fotos[indexFoto].id}`)
              .then(response => response.data)
              .then(data => {
                window.Materialize.toast('Foto excluída!', 4000)
                this.produto.fotos.splice(indexFoto, 1)
              })
          }
          if (foto.capa) {
            this.$nextTick(() => {
              this.produto.fotos[0].capa = true
            })
          }
        })
      }
    },
    computed: {
      ...mapState(['loading']),
      isNew () {
        return this.produto.id === ''
      },
      api_url () {
        return process.env.UPLOADS_URL
      }
    }
  }
</script>

<template>
  <div>

    <form @submit.prevent="validate">

      <div class="row">

        <div class="col s12 m10 offset-m1">

          <div>

            <div class="row">
              <div class="input-field col s12 m6">
                <input name="produto" id="produto" type="text" v-validate
                       data-vv-rules="required" :class="{invalid: errors.has('produto')}"
                       v-model="produto.produto"/>
                <label for="produto">*Produto</label>
                <small class="red-text">{{ errors.first('produto') }}</small>
              </div>
              <div class="input-field col s6 m3">
                <input name="codigo" id="codigo" type="text" v-model="produto.codigo"/>
                <label for="codigo">Código</label>
              </div>
              <div class="col s6 m3">
                <label for="perfil_id">*Unidade</label>
                <select name="perfil_id" id="perfil_id" v-validate data-vv-rules="required" v-model="produto.unidade_id">
                  <option v-for="unidade in unidades" :value="unidade.id">{{ unidade.unidade }}</option>
                </select>
                <small class="red-text">{{ errors.first('unidade_id') }}</small>
              </div>
            </div>

            <div class="row">

              <div class="col s6 m6">
                <label for="marca_id">*Marca</label>
                <select name="marca_id" id="marca_id" v-validate v-model="produto.marca_id">
                  <option v-for="marca in marcas" :value="marca.id">{{ marca.marca }}</option>
                </select>
                <small class="red-text">{{ errors.first('marca_id') }}</small>
              </div>

              <div class="col s6 m6">
                <label for="fornecedor_id">Fornecedor</label>
                <select name="fornecedor_id" id="fornecedor_id" v-validate v-model="produto.fornecedor_id">
                  <option v-for="fornecedor in fornecedores" :value="fornecedor.id">{{ fornecedor.fornecedor }}</option>
                </select>
                <small class="red-text">{{ errors.first('fornecedor_id') }}</small>
              </div>

            </div>

            <div class="row">
              <div class="col s6 m6">
                <label for="familia_id">Família</label>
                <select name="familia_id" id="familia_id" v-model="produto.familia_id" @change="familiaChange()">
                  <option v-for="familia in familias" :value="familia.id">{{ familia.familia }}</option>
                </select>
                <small class="red-text">{{ errors.first('familia_id') }}</small>
              </div>
              <div class="col s6 m6">
                <label for="categoria_id">Categoria</label>
                <select name="categoria_id" id="categoria_id" v-model="produto.categoria_id">
                  <option v-for="categoria in categorias" :value="categoria.id">{{ categoria.categoria }}</option>
                </select>
                <small class="red-text">{{ errors.first('categoria_id') }}</small>
              </div>
            </div>

            <div class="row">
              <div class="input-field col s6 m3">
                <input v-if="isNew" name="estoque" id="estoque" type="number" v-validate data-vv-rules="required" :class="{invalid: errors.has('estoque')}" v-model="produto.estoque"/>
                <input v-if="!isNew" readonly name="estoque" id="estoque" type="number" v-validate data-vv-rules="required" :class="{invalid: errors.has('estoque')}" v-model="produto.estoque"/>
                <label for="estoque">*Estoque</label>
                <small class="red-text">{{ errors.first('estoque') }}</small>
              </div>
              <div class="input-field col s6 m3">
                <input name="estoque_minimo" id="estoque_minimo" type="number" v-validate
                       data-vv-rules="required" :class="{invalid: errors.has('estoque_minimo')}"
                       v-model="produto.estoque_minimo"/>
                <label for="estoque_minimo">*Estoque Mínimo</label>
                <small class="red-text">{{ errors.first('estoque_minimo') }}</small>
              </div>
              <div class="input-field col s6 m3">
                <input name="valor_compra" id="valor_compra" type="number" step="any" v-validate
                       data-vv-rules="required" :class="{invalid: errors.has('valor_compra')}"
                       v-model="produto.valor_compra"/>
                <label for="valor_compra">*Valor Compra</label>
                <small class="red-text">{{ errors.first('valor_compra') }}</small>
              </div>
              <div class="input-field col s6 m3">
                <input name="valor_venda" id="valor_venda" type="number" step="any" v-validate data-vv-rules="required"
                       :class="{invalid: errors.has('valor_venda')}" v-model="produto.valor_venda"/>
                <label for="valor_venda">*Valor Venda</label>
                <small class="red-text">{{ errors.first('valor_venda') }}</small>
              </div>
            </div>

            <div class="row">

              <div class="input-field col s12 m3">
                <input name="loja" id="loja" type="checkbox" v-model="produto.loja">
                <label for="loja">Disponível na Loja</label>
              </div>

              <div class="input-field col s6 m3" v-show="produto.loja">
                <input name="valor_loja" id="valor_loja" type="number" step="any"
                       v-validate="produto.loja === true ? 'required' : ''" :class="{invalid: errors.has('valor_loja')}"
                       v-model="produto.valor_loja"/>
                <label for="valor_loja">*Valor Loja</label>
                <small class="red-text">{{ errors.first('valor_loja') }}</small>
              </div>

              <div class="input-field col s12 m6">
                <input name="ncm" id="ncm" type="text" v-validate
                       :class="{invalid: errors.has('ncm')}"
                       v-model="produto.ncm"/>
                <label for="ncm">NCM</label>
                <small class="red-text">{{ errors.first('ncm') }}</small>
              </div>

            </div>

            <div class="row">
              <div class="input-field col s12">
                <textarea name="descricao" class="materialize-textarea" id="descricao"
                          v-model="produto.descricao"></textarea>
                <label for="descricao">Descrição</label>
                <small class="red-text">{{ errors.first('descricao') }}</small>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col s12 m3 l2 center-align" v-for="(foto, indexFoto) in produto.fotos">
              <img :src="`${api_url}/produtos/${foto.foto}`" style="max-width: 90%; height: 50px;"
                   @click="setCapa(indexFoto)" class="pointer center-align"><br/>
              <input type="checkbox" :id="`capa-${indexFoto}`" :checked='foto.capa' v-model="foto.capa"
                     @click="setCapa(indexFoto)"/>
              <label :for="`capa-${indexFoto}`">Capa</label><br/>
              <div class="input-field col s12">
                <input name="legenda" :id="`legenda-${indexFoto}`" type="text"
                       v-model="foto.legenda"/>
                <label :for="`legenda-${indexFoto}`">Legenda</label>
              </div>
              <br/>
              <a href="#" @click.prevent="destroyFoto(indexFoto)">
                <i class="material-icons red-text">delete_forever</i>
              </a>
              <br clear="all"/>
            </div>

          </div>

          <div class="row">

            <div class="col s12 m3">

              <vue-clip :options="options" :on-complete="complete" :on-total-progress="totalProgress">
                <template slot="clip-uploader-action">
                  <div class="row">
                    <div class="col s12">
                      <div class="dz-message">
                        <div class="card">
                          <div class="center-align" style="width: 100%;">
                            <p class="center-align">clique para inserir imagens</p>
                          </div>
                        </div>
                      </div>
                      <div class="progress">
                        <div class="determinate" :style="`width: ${progress}%`"></div>
                      </div>
                      <div v-if="errorFile" class="center-align">Tipo de arquivo inválido</div>
                    </div>
                  </div>
                </template>
              </vue-clip>
            </div>
          </div>


          <div class="row">

            <div class="input-field col s12 m2">
              <input name="ativo" id="ativo" type="checkbox" v-model="produto.ativo">
              <label for="ativo">Ativo</label>
            </div>

          </div>
          <div class="row">

            <div class="input-field col s12">
              <button class="waves-effect waves-light btn" :disabled="loading">Salvar</button>
            </div>

          </div>

        </div>

      </div>

    </form>

  </div>
</template>



// WEBPACK FOOTER //
// src/features/produtos/form.vue